export default __webpack_public_path__ + "static/media/svg-5.29e9439b.svg";